import { CashTransactionDto } from "../../../dtos/transactions/CashTransactionDto";
import { format } from "date-fns";
import { DataGrid } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Grouping,
  GroupPanel,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";

interface IProps {
  items: CashTransactionDto[];
}

export const CashTransactionTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column
            dataField="tableMovementType"
            dataType="string"
            caption={"Movement Type"}
            width={100}
            cellRender={(column: any) => {
              return <MovementTypeColumn column={column} />;
            }}
          />

          <Column
            width={150}
            dataField={"period"}
            dataType={"datetime"}
            caption={"Period"}
            sortOrder={"asc"}
            sortIndex={1}
          />
          <Column width={150} dataField={"documentId"} dataType="string" />
          <Column width={150} dataField={"currencyId"} dataType="string" />
          <Column width={150} dataField={"currencyName"} dataType="string" />
          <Column width={150} dataField={"cashFlowItemId"} dataType="string" />
          <Column
            width={150}
            dataField={"cashFlowItemName"}
            dataType="string"
          />
          <Column width={150} dataField={"currencyAmount"} dataType="number" />
          <Column width={150} dataField={"documentType"} dataType="number" />
          <Column width={150} dataField={"cashRegisterId"} dataType="string" />
          <Column
            width={150}
            dataField={"cashRegisterName"}
            dataType="string"
          />

          <Column
            width={75}
            dataField={"amount"}
            dataType="string"
            caption={"Amount"}
          />

          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
